import { axiosInstance } from '@/axios'
import { basePanelsRoute, langObjArr } from '@/constants.js'
import config from '@/config.js'
import router from '@/router/index.js'

export default {
  state: {
    user: null,
    lang: null,
    directionSystem: null,
    library: null,
    showLoader: true,
    availableLibraries: null,
    popupLoading: false,
    libraryDataUploaded: false,
    originOfClient: 'IL', // TODO get origin of client from session and put here.
    toggleBaseMenu: null,
    userRoles: null,
    panelRoute: null
  },
  mutations: {
    SET_PANEL_ROUTE (state, route) {
      state.panelRoute = route
    },
    SET_ALL_LIBRARIES (state, libraries) {
      state.availableLibraries = libraries
    },
    SET_LIBRARY (state, library) {
      state.library = library
    },
    SET_DIRECTION (state, value) {
      state.directionSystem = value
    },
    SET_LANG (state, langObj) {
      state.lang = langObj
    },
    SET_LOADER (state, value) {
      state.showLoader = value
    },
    SET_POPUP_LOADING (state, val) {
      state.popupLoading = val
    },
    SET_ORIGIN_OF_CLIENT (state, val) {
      state.originOfClient = val
    },
    SET_USERS_DATA (state, usersData) {
      state.user = {}
      state.user.firstName = usersData.first_name
      state.user.lastName = usersData.last_name
      state.user.username = usersData.username
      state.user.email = usersData.email
      state.user.external = (usersData.email === 'idm@class.world')
      state.user.uid = usersData.pk
      state.user.uuid = usersData.profile.uuid
      this.dispatch('captureEventLibrary', { name_evnet: 'user_insert_to_library', obj: state.user })
    },
    SET_LIBRARY_DATA_UPLOADED (state) {
      state.libraryDataUploaded = true
    },
    TOGGLE_BASE_LIBRARY_MENU (state, val) {
      state.toggleBaseMenu = val
    },
    SET_USER_ROLES (state, val) {
      state.userRoles = val
    }
  },
  actions: {
    setAttributeLang ({ state }) {
      return document.querySelector('html')?.setAttribute('lang', state.lang.localName)
    },
    setPanelRoute ({ commit }, route) {
      commit('SET_PANEL_ROUTE', route)
    },
    goCollectionEntryDirect (context) {
      if (localStorage.getItem('requestedUrl')) {
        const url = localStorage.getItem('requestedUrl')
        localStorage.removeItem('requestedUrl')
        router.replace(url)
        return true
      } else if (localStorage.getItem('collectionEntry')) {
        const collectionEntryId = localStorage.getItem('collectionEntry')
        localStorage.removeItem('collectionEntry')
        router.push({ name: 'collectionEntry', params: { id: collectionEntryId } })
        return true
      } else {
        return false
      }
    },
    setPopupLoading (context, val) {
      context.commit('SET_POPUP_LOADING', val)
    },
    captureEventLibrary (context, data) {
      const obj = data.obj
      obj.uuid = context.state.user.uuid
      obj.library_slug = context.state.library?.slug
      posthog.capture(data.name_evnet, obj) // eslint-disable-line no-undef
    },
    getUserProfile (context) {
      return axiosInstance.get(config.authURL + 'user/').then(res => {
        const user = res.data
        localStorage.setItem('user', JSON.stringify(user))
        context.commit('SET_USERS_DATA', {
          first_name: user.first_name,
          last_name: user.last_name,
          username: user.username,
          pk: user.pk,
          email: user.email,
          profile: { uuid: user.profile.uuid }
        })
      })
    },
    login (context, user) {
      return axiosInstance.post(config.authURL + 'login/', {
        username: user.userName,
        password: user.pass,
        captcha: user.captcha
      })
    },
    signUp (context, newUser) {
      return axiosInstance.post(config.authURL + 'registration/', {
        username: newUser.userName,
        password1: newUser.pass,
        password2: newUser.pass,
        email: newUser.email,
        first_name: newUser.privateName,
        last_name: newUser.famelyName,
        lang: context.state.lang.localName,
        metadata: {
          institution: newUser.institution,
          city: newUser.city,
          country: newUser.country
        },
        captcha: newUser.captcha
      })
    },
    checkEmailAndUsername (context, details) {
      return axiosInstance.post(config.authURL + 'password/reset/', {
        email: details.email,
        username: details.username,
        url: details.url
      })
    },
    changePasswordOfUser (context, details) {
      return axiosInstance.post(config.authURL + 'password/reset/confirm/', {
        new_password1: details.newPassword,
        new_password2: details.repeatNewPassword,
        uid: details.uid,
        token: details.token
      })
    },
    submitEditorPincode (context, pincode) {
      return axiosInstance.get(config.baseURL + 'nonce/?nonce=' + pincode)
        .then((response) => {
          return response
        }).catch((error) => {
          throw error
        })
      // // TODO set backend to check if pincode is good, if it is set user as editor in this library
      // const isPincodeGood = true
      // // const isPincodeGood = false
      // return (isPincodeGood)
    },
    getAllLibraries ({ commit }) {
      return axiosInstance.get('library/').then(response => {
        commit('SET_ALL_LIBRARIES', response.data.filter(lib => !lib.slug.includes('ramot')))
      })
    },
    getRoles (context, librarySlug) {
      // Check if user is editor in the library
      return axiosInstance.get('library/' + librarySlug + '/roles/').then((response) => {
        const roles = response.data
        const readerIndex = roles.indexOf('reader')
        roles.splice(readerIndex, 1)
        context.commit('SET_USER_ROLES', roles)
      })
    },
    getLibraryInfo ({ commit }, librarySlug) {
      return axiosInstance.get('library/' + librarySlug + '/landing-page/').then((response) => {
        commit('SET_LIBRARY', response.data)
        if (!sessionStorage.getItem('lang')) {
          // Split lang (because we get lang like: he_IL)
          const langName = response.data.lang.split('_')[0]
          const langObj = langObjArr.find(l => l.localName === langName)
          this.dispatch('setLang', langObj)
        } else {
          this.dispatch('setLang', JSON.parse(sessionStorage.getItem('lang')))
        }
        const favicon = document.getElementById('favicon')
        favicon.href = response.data.metadata.favicon
        const siteTitle = document.getElementById('siteTitle')
        siteTitle.innerHTML = response.data.title
        commit('SET_LOADER', false)
      })
    },
    getLibrary ({ commit, state }, librarySlug) {
      return axiosInstance.get('library/' + librarySlug).then(async (response) => {
        commit('SET_LIBRARY', response.data)
        if (!sessionStorage.getItem('lang')) {
          // Split lang (because we get lang like: he_IL)
          const langName = response.data.lang.split('_')[0]
          const langObj = langObjArr.find(l => l.localName === langName)
          this.dispatch('setLang', langObj)
        } else {
          this.dispatch('setLang', JSON.parse(sessionStorage.getItem('lang')))
        }
        const favicon = document.getElementById('favicon')
        favicon.href = response.data.metadata.favicon
        const siteTitle = document.getElementById('siteTitle')
        siteTitle.innerHTML = response.data.title
        const getLibraryRootCollections = this.dispatch('getLibraryRootCollections')
        const getLibraryClassifications = this.dispatch('getLibraryClassifications')
        const getLibraryFields = this.dispatch('getLibraryFields')
        await Promise.all([getLibraryRootCollections, getLibraryClassifications, getLibraryFields])
        if (state.panelRoute === basePanelsRoute.contentApproval) {
          await this.dispatch('getContentApprovalEntries')
        } else {
          this.dispatch('getContentApprovalEntries')
        }
        // set spinner to false after all component are rendered - spinner is showed until spinner is set to false
        commit('SET_LOADER', false)
        commit('SET_LIBRARY_DATA_UPLOADED')
      })
    },
    setLoader ({ commit }, value) {
      commit('SET_LOADER', value)
    },
    setDirection ({ commit, state }, value) {
      sessionStorage.setItem('direction', value)
      // If we need to replace direction
      if (state.directionSystem && state.directionSystem !== value) { location.reload() }
      commit('SET_DIRECTION', value)
    },
    setLang ({ commit }, langObj) {
      commit('SET_LANG', langObj)
      const dirSys = ['he', 'ar'].indexOf(langObj.localName) >= 0 ? 'rtl' : 'ltr'
      sessionStorage.setItem('lang', JSON.stringify(langObj))
      this.dispatch('setDirection', dirSys)
    },
    signOut (context) {
      localStorage.removeItem('jwt')
      localStorage.removeItem('user')
      sessionStorage.clear()
      return axiosInstance.post(config.authURL + 'logout/', {})
    },
    getOriginOfClient (context) {
      // TODO return from DB origin
      console.log('client origin')
    },
    goToGoogleSso (context) {
      const url = process.env.VUE_APP_AUTH_URL + 'accounts/classe_google/login/?next=' + location.origin + process.env.VUE_APP_PUBLIC_PATH + context.state.library.slug + '/check-permissions'
      location.href = url
    },
    goToIdmSso (context) {
      const url = process.env.VUE_APP_AUTH_URL + 'accounts/idm/login/?next=' + location.origin + '/library/' + context.state.library.slug + '/check-permissions'
      location.href = url
    },
    setPublishOptions ({ commit }, bool) {
      commit('SET_PUBLISH_OPTIONS', bool)
    },
    setUserData ({ commit }, usrsData) {
      commit('SET_USERS_DATA', usrsData)
    },
    toggleBaseLibraryMenu ({ commit }, value) {
      commit('TOGGLE_BASE_LIBRARY_MENU', value)
    },
    getAutoCompleteValues ({ state }, fieldKey) {
      return axiosInstance.get('library/' + state.library.slug + '/fields-values/', {
        params: {
          key: fieldKey
        }
      }).then(response => {
        return response.data
      })
    }
  }
}
